<template>
  <div
    class="tw:lg:relative tw:max-w-[310px] tw:lg:max-w-[382px] tw:whitespace-normal tw:text-left tw:shadow-[2px_2px_4px_0px_rgba(0,0,0,0.25)] tw:bg-white tw:rounded-xl tw:px-6 tw:lg:pl-12 tw:py-5 tw:border tw:border-gray-300 tw:lg:flex tw:lg:flex-col tw:lg:justify-center"
  >
    <div class="tw:flex tw:items-center tw:gap-4">
      <CircleArrowIcon
        :class="['tw:lg:hidden tw:w-[35px] tw:h-[35px] tw:md:w-[40px] tw:md:h-[40px]', iconSvgProps?.class]"
        :style="iconSvgProps?.circleInnerColor ? { fill: iconSvgProps.circleInnerColor } : undefined"
      />
      <h2 class="tw:font-bold tw:lg:text-xl tw:leading-[20px]">{{ $t(item.title) }}</h2>
    </div>
    <p v-if="item.id === 'sliderc_0'" class="tw:text-sm tw:lg:text-base tw:mt-2">
      {{ $t(item.text, { CommissionRate: commissions }) }}
    </p>
    <p v-else class="tw:text-sm tw:lg:text-base tw:mt-2">{{ $t(item.text) }}</p>
    <CircleArrowIcon
      :class="[
        'tw:hidden tw:lg:block tw:absolute tw:w-[45px] tw:h-[45px] tw:-left-4 tw:top-1/2 tw:-translate-y-1/2',
        iconSvgProps?.class,
      ]"
      :style="iconSvgProps?.circleInnerColor ? { fill: iconSvgProps.circleInnerColor } : undefined"
    />
  </div>
</template>

<script setup>
import { computed } from 'vue'

import CircleArrowIcon from '@/components/icons/RcBenefitsCircleArrowIcon.svg?component'

import { useSessionValues } from '@/composables/useSessionValues'

defineProps({
  item: {
    type: Object,
    required: true,
  },
  iconSvgProps: {
    type: Object,
    required: false,
  },
})

const { language } = useSessionValues()
const commissions = computed(() =>
  [12, 15, 18, 20, 25]
    .map(item =>
      new Intl.NumberFormat(language.value, {
        style: 'percent',
      }).format(item / 100)
    )
    .join(', ')
)
</script>
